export default __webpack_public_path__ + "static/media/partner-ofb.6a83326b.jpg";